module.exports = __webpack_public_path__ + "img/Logo_Elettra_Social_bianco_v2.1b4220bf.png";